const types = {
	ADD_FLASH_MESSAGE: 'ADD_FLASH_MESSAGE',
	NEXT_PAGE: 'NEXT_PAGE'
}

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/flash-messages/mutation-types.js